import CryptoJS from 'crypto-js';
/**
 * @word 要加密的内容
 */

const aesEncrypt = (word: string) => {
  const AES_KEY = CryptoJS.enc.Utf8.parse('0MuKxNQwCt5qyWKn'); // 16字节密钥
  const AES_IV = CryptoJS.enc.Utf8.parse('FIAsrG8RZXpaShX2'); // 16字节IV
  const secs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(secs, AES_KEY, {
    iv: AES_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};

function aesCodeEncrypt (word: string, keyWord: string = 'XwKsGlMcdPMEhR1B') {
  const key = CryptoJS.enc.Utf8.parse(keyWord);
  const secs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(secs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return encrypted.toString();
}

/**
 * @word 要解密的内容
 * @keyWord String  服务器随机返回的关键字
 */
function aesCodeDecrypt (word: string, keyWord: string = 'XwKsGlMcdPMEhR1B') {
  const key = CryptoJS.enc.Utf8.parse(keyWord);
  const decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

export {
  aesEncrypt,
  aesCodeEncrypt,
  aesCodeDecrypt
};
